export const DeduplicationPhysician = {
    path: '/deduplication/physician',
    name: 'deduplication.physician',
    component: () => import('@/views/Identical/DeduplicationPhysicianPage.vue'),
    children: [
        {
            path: '/deduplication/physician/edit/:id',
            name: 'deduplication.physician.edit',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {updateAction: true, type: 'physician'},
        },
        {
            path: '/deduplication/physician/delete/:id',
            name: 'deduplication.physician.delete',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {deleteAction: true, type: 'physician'},
        },
        {
            path: '/deduplication/physician/view/:id',
            name: 'deduplication.physician.view',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {viewAction: true, type: 'physician'},
        },
        {
            path: '/deduplication/physician/visit/view/:id',
            name: 'deduplication.physician.visit.view',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {viewAction: true, type: 'physician'},
        },
    ]
}